import { apiClient } from './client';
import { BoondProject, ProjectsFilter } from '@gridwise/shared';

export async function getProjects(
  filters: ProjectsFilter = {},
): Promise<{ data: BoondProject[]; pagination: any }> {
  const response = await apiClient.get('/projects', { params: filters });
  return response.data;
}

export async function getProjectById(id: string): Promise<BoondProject> {
  const response = await apiClient.get(`/projects/${id}`);
  return response.data.data;
}
